import { render, staticRenderFns } from "./HasSauna.vue?vue&type=template&id=ed381326&"
import script from "./HasSauna.vue?vue&type=script&lang=ts&"
export * from "./HasSauna.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports